import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialState } from './state'
import activeScript from '../active-script'
import scriptEdit from '../script-edit'
import scriptPage from '../script-page'

export default {
  getters,
  actions,
  mutations,
  state: initialState,
  modules: {
    scriptEdit,
    activeScript,
    scriptPage,
  },
}
